// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

import { createElement, Alert, Component, PropTypes } from '@plesk/ui-library';

class ClosableAlert extends Component {
    state = {
        isOpen: true,
    };

    render() {
        const { children, onClose } = this.props;

        return this.state.isOpen ? (
            <Alert
                intent="info"
                onClose={() => {
                    onClose();
                    this.setState({
                        isOpen: false,
                    });
                }}
            >
                {children}
            </Alert>
        ) : null;
    }
}

ClosableAlert.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default ClosableAlert;



// WEBPACK FOOTER //
// ./app/profile/closable-alert.js